import { render, staticRenderFns } from "./zPercentualMaquina.vue?vue&type=template&id=fb4d68d4&scoped=true&"
import script from "./zPercentualMaquina.vue?vue&type=script&setup=true&lang=js&"
export * from "./zPercentualMaquina.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb4d68d4",
  null
  
)

export default component.exports